import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 9 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.172 3.357a.588.588 0 0 1 0-.832L2.525.172a.588.588 0 0 1 .832 0L5.71 2.525a.588.588 0 0 1-.832.832L3.53 2.008v6.816a.588.588 0 1 1-1.176 0V2.008l-1.349 1.35a.588.588 0 0 1-.832 0Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.703 6.643a.588.588 0 0 1 0 .832L3.35 9.828a.588.588 0 0 1-.832 0L.165 7.475a.588.588 0 0 1 .832-.832l1.349 1.35V1.176a.588.588 0 0 1 1.176 0v6.815l1.35-1.349a.588.588 0 0 1 .83 0Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render };